<template>
  <a-layout class="create-application-box">
    <a-card class="create-application" :bordered=false>
      <div slot="title" v-if="pageLayout.pageTitle">
        <a-icon style="cursor:pointer;" type="left-circle" @click="back" />
        <div>{{pageLayout.pageTitle}}</div>
      </div>
      <div v-for="(layout,index) in pageLayout.contents" :key="index" v-if="loadedInfo && loadedLayout">
        <common-form v-if="layout.type==='commonForm'" :ref="`commonForm_${layout.field}`" :layout="layout" :params="layout.field && params[layout.field]?params[layout.field]:{}" :can-edit="canEdit" :need-id="true" @changed-fields="onFieldChange" @current-changed-field="getCurrentChanged" @update="update" @event-relay="eventRelay"></common-form>
        <multi-form :ref="`multiForm_${layout.field}`" :layout="layout" v-if="layout.type==='multiForm'" :can-add="multiFormCanAdd" :params="layout.field && params[layout.field]?params[layout.field]:[]" :default-params="defaultParams" :can-edit="canEdit" :need-id="true" @changed-fields="onFieldChange" @current-changed-field="getCurrentChanged" @update="update"></multi-form>
        <summation :layout="layout" v-if="layout.type==='summation'" :params="params[layout.field]?params[layout.field]:{}" :all-params="params" @changed-fields="setSummationInfo"></summation>
        <upload v-if="layout.type==='upload'" :layout="layout" :params="params[layout.field]?params[layout.field]:[]" :can-edit="canEdit" @changed-fields="onFieldChange"></upload>
        <a-divider/>
      </div>
      <approval-flow :params="approvalFlowInfo" :init-text="'必填信息填写后，流程将自动显示'" v-if="loadedInfo && loadedLayout"></approval-flow>
      <a-row style="margin:30px 0 24px;" v-if="loadedInfo && loadedLayout">
        <a-col :xs="24" :sm="4"></a-col>
        <a-col :xs="24" :sm="10">
          <a-button type="primary" style="width:120px;margin-right: 18px" :disabled="!canSubmit" @click="submit">提交</a-button>
          <a-button @click="visibleComment = true" style="width:120px;">评论</a-button>
        </a-col>
      </a-row>
      <div style="text-align:center" v-else>
        <a-spin tip="数据加载中..."></a-spin>
      </div>
      <a-modal class="introductionModal" :title="pageLayout.introduction.title" v-if="pageLayout.introduction" v-model="introductionVisible" @ok="introductionVisible=false" :okText="'关闭'">
        <div>
          <pre style="font-size: 14px;color: rgba(0,0,0,0.65);line-height: 22px;text-align:left">{{pageLayout.introduction.description}}</pre>
        </div>
      </a-modal>
      <comment-and-copy :visible="visibleComment" @cancel="visibleComment = false" @reload="reload"></comment-and-copy>
    </a-card>
  </a-layout>
</template>

<script>
import UUID from "uuidjs";
import SvgIcAll from "../../assets/svg/ic-all-o.svg";
import CommonForm from "../../components/CommonForm.vue";
import MultiForm from "../../components/MultiForm.vue";
import Summation from "../../components/Summation.vue";
import ApprovalFlow from "../../components/ApprovalFlow.vue";
import Upload from "../../components/Upload.vue";
import { setTimeout } from "timers";
import LayoutConfig from "../../utils/LayoutConfig.js";
import { layoutConfig } from "../../utils/mockData.js";
import {
  getProReimburseLayout,
  getProReimburseDetailLayout,
  getCreateProReimburseParams,
  submitProReimburse,
  getProReimburseFlow,
  getProReimburseEditParams
} from "../../services/CommonService.js";

export default {
  components: {
    SvgIcAll,
    CommonForm,
    MultiForm,
    Summation,
    ApprovalFlow,
    Upload
  },
  data() {
    return {
      introductionVisible: false,
      canEdit: true,
      breadcrumb: [
        {
          label: "发起申请",
          path: {
            name: "launchApplication"
          }
        },
        {
          label: "发起报销申请",
          path: ""
        }
      ],
      params: {},
      defaultParams: {}, // 复制时需要用到创建用到的默认参数
      loadedLayout: false,
      loadedInfo: false,
      canSubmit: true,
      pageLayout: {},
      approvalFlowInfo: [],
      summationInfo: {},
      requestParams: {},
      cancelSource: null,
      multiFormCanAdd: true,
      visibleComment: false
    };
  },

  created() {
    Promise.all([this.getProReimburseEditParams()]).then(() => {
      this.fetchPageLayout();
      getCreateProReimburseParams({
        provide_invoices:
          this.params &&
          this.params.basicInfo &&
          this.params.basicInfo.provide_invoices
            ? this.params.basicInfo.provide_invoices
            : 1,
        type: "default",
        detail_type: this.params.detailInfo[0].type
      }).then(res => {
        if (res.status === "success") {
          this.defaultParams = Object.assign({}, this.defaultParams, res.data); // 页面默认参数
        } else {
          this.$Message.error(res.message);
        }
      });
    });
  },
  mounted() {},
  beforeDestroy() {},

  computed: {
    approvalFlowDependParams() {
      const params = _.cloneDeep(this.requestParams);
      if (this.requestParams.basicInfo && this.requestParams.total_pay) {
        return {
          project_id: this.requestParams.basicInfo.project_id,
          company_id: this.requestParams.basicInfo.company_id,
          total_pay: this.requestParams.total_pay
        };
      }
    }
  },

  methods: {
    onFieldChange(e) {
      console.log(e);
      this.params = Object.assign({}, this.params, e);
      LayoutConfig.setAllParams(this.params);
      this.requestParams = _.cloneDeep(this.params);
    },
    setSummationInfo(e) {
      this.summationInfo = e;
      this.requestParams = _.cloneDeep(this.params);
      this.requestParams = Object.assign(
        this.requestParams,
        this.summationInfo
      );
    },
    // 获取整个页面表单布局
    fetchPageLayout() {
      this.loadedLayout = false;
      getProReimburseLayout({
        id: this.$route.query.id,
        show_type: "create",
        provide_invoices:
          this.params &&
          this.params.basicInfo &&
          this.params.basicInfo.provide_invoices
            ? this.params.basicInfo.provide_invoices
            : 1,
        detail_type:
          this.params && this.params.detailInfo
            ? this.params.detailInfo[0].type
            : undefined,
        ding_msg_switch:
          window.location.href.indexOf("fromLocation=msg") !== -1 ? 1 : 0
      }).then(res => {
        if (res.status === "success") {
          this.pageLayout = res.data;
          this.loadedLayout = true;
        } else {
          this.$Message.error(res.message);
          this.loadedLayout = true;
        }
      });
    },
    fetchApprovalFlow() {
      this.approvalFlowInfo = [];
      this.cancelQuest();
      getProReimburseFlow(this.requestParams, this).then(res => {
        if (res.status === "success") {
          if (res.data && _.isArray(res.data)) {
            res.data.forEach((item, index) => {
              this.$set(this.approvalFlowInfo, index, item);
            });
          }
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    // 获取页面表单初始默认值
    getCreateProReimburseParams(detail_type, info_type) {
      return getCreateProReimburseParams({
        provide_invoices:
          this.params &&
          this.params.basicInfo &&
          this.params.basicInfo.provide_invoices
            ? this.params.basicInfo.provide_invoices
            : 1,
        type: info_type,
        detail_type: detail_type
      }).then(res => {
        if (res.status === "success") {
          this.loadedInfo = true;
          if (info_type === "cache") {
            this.paramsBackup = _.cloneDeep(res.data);
            this.params = {};
            this.params = Object.assign({}, this.params, res.data);
            LayoutConfig.setAllParams(this.params);
          } else {
            this.defaultParams = Object.assign(
              {},
              this.defaultParams,
              res.data
            ); // 页面默认参数
          }
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    // 获取复制的申请单详情信息
    getProReimburseEditParams() {
      return getProReimburseEditParams(this.$route.query.id, {
        menu_type: 1
      }).then(res => {
        if (res.status === "success") {
          this.paramsBackup = _.cloneDeep(res.data);
          LayoutConfig.setAllParams(this.params);
          this.params = Object.assign({}, this.params, res.data);
          this.loadedInfo = true;
          // this.defaultParams = Object.assign({}, this.defaultParams, res.data); // 页面默认参数
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    submit() {
      let validateResult = true;
      Object.keys(this.$refs).forEach(key => {
        if (key.indexOf("commonForm") || key.indexOf("multiForm")) {
          this.$refs[key].forEach(item => {
            if (!item.validateFields()) {
              validateResult = false;
            }
          });
        }
      });
      if (validateResult) {
        this.canSubmit = false;
        delete this.requestParams.system_cache;
        this.requestParams.basicInfo.id = this.$route.query.id;
        // clearInterval(this.systemCacheTimer);
        submitProReimburse(this.requestParams).then(res => {
          if (res.status === "success") {
            this.$Message.success("修改申请成功");
            this.$router.replace({
              name: "myApplicationList",
              query: {
                apply_type: 9
              }
            });
          } else {
            this.$Message.error(res.message);
            this.systemCacheTimer = setInterval(this.systemCache, 20000);
          }
          this.canSubmit = true;
        });
      }
    },
    update(e) {
      this.fetchLayout();
    },
    back() {
      this.$router.replace({
        name: "myApplicationList",
        query: {
          apply_type: 9
        }
      });
    },
    getNeighorByField(val) {
      let vm = null;
      Object.keys(this.$refs).forEach(key => {
        const field = key.substr(key.indexOf("_") + 1);
        if (field === val) {
          vm = this.$refs[key];
        }
      });
      return vm[0];
    },
    eventRelay(e) {
      const self_event = e[0];
      let behind_event = _.cloneDeep(e);
      behind_event.shift();
      if (self_event.selfDo === "emit") {
        this.$emit("event-relay", behind_event);
      } else if (self_event.selfDo === "passNeighor") {
        let neighorVm = this.getNeighorByField(self_event.params.value);
        neighorVm.eventRelay(behind_event);
      }
    },
    cancelQuest() {
      if (typeof this.cancelSource === "function") {
        this.cancelSource("终止请求"); //取消请求
      }
    },
    getCurrentChanged(e) {
      if (Object.keys(e)[0] === "provide_invoices") {
        this.params.detailInfo.forEach((item, index) => {
          this.updateFormDetailConfig(item.type, index, 1);
        });
      } else if (
        !e.isFromBasciInfo &&
        Object.keys(e)[0] === "type" &&
        e.type.value
      ) {
        this.updateFormDetailConfig(e.type.value, e.type.ofMultiFormIndex);
      } else if (e.isFromBasciInfo && Object.keys(e)[0] === "support_team_id") {
        this.defaultParams.detailInfo[0].budget_subject_id =
          e.selectObj.display_budget_subject;
        this.$refs.multiForm_detailInfo.forEach(item => {
          item.updateChildConfig(
            "budget_subject_id",
            e.selectObj.display_budget_subject
          );
        });
      }
    },

    updateFormDetailConfig(detail_type, detail_index, default_flag = 0) {
      getCreateProReimburseParams({
        detail_type: detail_type,
        provide_invoices:
          this.params &&
          this.params.basicInfo &&
          this.params.basicInfo.provide_invoices
            ? this.params.basicInfo.provide_invoices
            : 1,
        type: "default"
      }).then(res => {
        if (res.status === "success") {
          const currentDefaultParams = res.data.detailInfo
            ? res.data.detailInfo
            : [{}];
          if (default_flag && detail_index === 0) {
            // 为后面新增明细的操作以第一条明细参数为模板
            this.defaultParams = res.data;
          }
          getProReimburseDetailLayout({
            show_type: "create",
            detail_type: detail_type,
            provide_invoices: this.params.basicInfo.provide_invoices
          }).then(result => {
            if (result.status === "success") {
              if (default_flag && detail_index === 0) {
                // 为后面新增明细的操作以第一条明细布局为模板
                let multiFormConfig = this.pageLayout.contents.find(
                  item => item.type === "multiForm"
                );
                multiFormConfig.contents = result.data;
              }
              this.$refs.multiForm_detailInfo.forEach(item => {
                item.refreshFormConfig(
                  detail_index,
                  result.data,
                  currentDefaultParams
                );
              });
            } else {
              this.$Message.error(result.message);
            }
          });
        } else {
          this.$Message.error(res.message);
        }
      });
    },

    reload() {
      this.visibleComment = false;
      this.fetchApprovalFlow();
    }
  },
  watch: {
    approvalFlowDependParams: {
      handler(val) {
        if (
          val &&
          val.project_id &&
          val.company_id &&
          val.total_pay &&
          val.total_pay !== "0.00"
        ) {
          this.copyVal = _.cloneDeep(val);
          this.fetchApprovalFlow();
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="less">
.create-application-box {
  padding: 16px;
}
.introductionModal {
  .ant-modal-footer {
    .ant-btn-default {
      display: none;
    }
  }
}
</style>
